<div class="wrapper">
  <span
    >You're attemping to logout of Accutrax. If you have data which needs to be
    synced please sync before logging out.</span
  >
  <span class="warning"
    >Logging out without syncing will result in all data being lost.</span
  >
  <div class="buttons">
    <button (click)="closeDialog()" mat-raised-button>Cancel</button>
    <button (click)="closeAndLogout()" mat-raised-button color="warn">
      Confirm Logout
    </button>
  </div>
</div>
